import { Link, NavLink } from "react-router-dom";
import { Phone, Menu, X } from "lucide-react";
import { useState } from "react";
import Logo from "./Logo";
import { CLINIC } from "../lib/api";

const NAV = [
  { to: "/", label: "Acasă" },
  { to: "/prima-consultatie", label: "Prima consultație" },
  { to: "/despre", label: "Despre" },
  { to: "/servicii", label: "Servicii" },
  { to: "/articole", label: "Articole" },
  { to: "/galerie", label: "Galerie" },
  { to: "/programare", label: "Programare" },
  { to: "/voluntariat", label: "Voluntariat" },
  { to: "/contact", label: "Contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 bg-white/85 backdrop-blur-xl border-b border-brand-beige">
      <div className="max-w-7xl mx-auto container-x py-3 flex items-center justify-between gap-4">
        <Link to="/" className="shrink-0" data-testid="header-logo-link">
          <Logo />
        </Link>

        <nav className="hidden lg:flex items-center gap-0.5" data-testid="header-nav">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.to === "/"}
              className={({ isActive }) =>
                `px-3 py-2 rounded-full text-[13px] font-semibold transition-colors ${
                  isActive
                    ? "bg-brand-navy text-white"
                    : "text-brand-navy/85 hover:bg-brand-cream"
                }`
              }
              data-testid={`nav-${n.to.replace('/','') || 'home'}`}
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-2">
          <a
            href={CLINIC.phoneTel}
            className="inline-flex items-center gap-2 px-4 py-2.5 rounded-full bg-brand-red text-white font-semibold text-sm shadow-soft hover:bg-brand-redSoft transition-colors"
            data-testid="header-call-button"
          >
            <Phone className="w-4 h-4" />
            {CLINIC.phonePretty}
          </a>
        </div>

        <button
          className="lg:hidden p-2 rounded-full bg-brand-yellow text-brand-navy"
          onClick={() => setOpen(!open)}
          aria-label="Meniu"
          data-testid="mobile-menu-toggle"
        >
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-white border-t border-brand-beige">
          <div className="max-w-7xl mx-auto container-x py-3 flex flex-col gap-1">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.to === "/"}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `px-4 py-3 rounded-2xl text-sm font-semibold ${
                    isActive ? "bg-brand-navy text-white" : "text-brand-navy hover:bg-brand-cream"
                  }`
                }
                data-testid={`mobile-nav-${n.to.replace('/','') || 'home'}`}
              >
                {n.label}
              </NavLink>
            ))}
            <a
              href={CLINIC.phoneTel}
              className="mt-2 inline-flex items-center justify-center gap-2 px-4 py-3 rounded-2xl bg-brand-red text-white font-semibold"
              data-testid="mobile-call-button"
            >
              <Phone className="w-4 h-4" /> {CLINIC.phonePretty}
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
